import React from 'react'
import Grid from 'material-ui/Grid'
import { withStyles } from 'material-ui/styles'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles'

import Title from '../ui/title'
import Content from '../ui/content'
import SettingsManufacturer from './manufacturer'
import SettingsCopperLimits from './copperlimits'
import SettingsDeviceSoftware from './devicesoftware'
import LT4CopperLimits from './lt4copperlimits'
import LT4AdapterPolicy from './lt4adapterpolicy'
import SettingsFiberlimits from './fiberlimits'
class Settings extends React.Component {
  render() {
    const {
      translate,
      uploadLimitDb,
      uploadManufacturerDb,
      uploadDeviceSoftware,
      uploadLt4LimitDb,
      uploadFiberFilesDb,
      uploadAdapterPolicy,
      log,
      impersonating,
      softwareUpdate
    } = this.props;

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    return (
      <div style={{marginTop: margintop}}>
        <Title title={translate("general_settings")} />
        <Content translate={translate}>
          <Grid container>
            <Grid item xs={12} sm={6} md={4}>
              <SettingsDeviceSoftware translate={translate} uploadDeviceSoftware={uploadDeviceSoftware} log={log} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SettingsManufacturer translate={translate} uploadManufacturerDb={uploadManufacturerDb} log={log} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SettingsCopperLimits translate={translate} uploadLimitDb={uploadLimitDb} log={log} />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={6} md={4}>
              <LT4CopperLimits translate={translate} uploadLt4LimitDb={uploadLt4LimitDb} log={log} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <LT4AdapterPolicy translate={translate} uploadAdapterPolicy={uploadAdapterPolicy} log={log} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SettingsFiberlimits translate={translate} uploadFiberFilesDb={uploadFiberFilesDb} log={log} />
            </Grid>
          </Grid>
        </Content>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Settings);

